// extracted by css-extract-rspack-plugin
export default {"hover":"hover-gJT6A2"};